import { render } from "./document-module.vue?vue&type=template&id=f2083c40&scoped=true"
import script from "./document-module.vue?vue&type=script&lang=js"
export * from "./document-module.vue?vue&type=script&lang=js"

import "./document-module.vue?vue&type=style&index=0&id=f2083c40&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2083c40"]])

export default __exports__